import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CalendarEvent } from 'angular-calendar';
import * as moment from 'moment';
import { AppService } from 'src/app/app.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import * as _ from 'underscore';
import { SkillztankCalendarEvent } from '../../../../shared/models/event.model';
import { AppCalendarService } from '../app-calendar.service';

interface DialogData {
  event?: CalendarEvent;
  action?: string;
  date?: Date;
}
@Component({
  selector: 'app-calendar-form-dialog',
  templateUrl: './calendar-form-dialog.component.html',
  styleUrls: ['./calendar-form-dialog.component.scss'],
  standalone: false,
})
export class CalendarFormDialogComponent implements OnInit, OnDestroy {
  contentID;
  event: CalendarEvent;
  dialogTitle: string;
  eventForm: UntypedFormGroup;
  action: string;
  selectedFreq = 'Unrepeated';
  userList;
  view = 'todoDetails';
  readonly freq = [
    { name: 'Non répété', value: 'Unrepeated' },
    { name: 'Quotidien', value: 'Daily' },
    { name: 'Hebdomadaire', value: 'Weekly' },
    { name: 'Mensuel', value: 'Monthly' },
    // { name: 'Annuel', value: "Yearly" }
  ];
  shareMenuData = {
    isEvent: true,
    event: {},
  };
  data;
  readonly weekDays = [
    { name: 'Dimanche', value: 0 },
    { name: 'Lundi', value: 1 },
    { name: 'Mardi', value: 2 },
    { name: 'Mercredi', value: 3 },
    { name: 'Jeudi', value: 4 },
    { name: 'Vendredi', value: 5 },
    { name: 'Samedi', value: 6 },
  ];
  readonly weeksOfMonth = [
    { name: 'première', value: 0 },
    { name: 'deuxième', value: 1 },
    { name: 'troisième', value: 2 },
    { name: 'quatrième', value: 3 },
  ];
  canEdit = false;
  appNameIsDemo: boolean;

  constructor(
    @Optional() public dialogRef: MatDialogRef<CalendarFormDialogComponent>,
    @Optional()
    public bottomSheetRef: MatBottomSheetRef<CalendarFormDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private bottomSheetData: any,
    private translate: TranslateService,
    private calendarService: AppCalendarService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,
    private appService: AppService,
    private toast: ToastService
  ) {
    this.appNameIsDemo = this.appService.appNameIsDemo();
    calendarService.newEventUsers$.subscribe((users) => (this.userList = users));

    const data = this.dialogData || this.bottomSheetData;

    this.data = data;
    this.event = data.event;
    this.action = data.action;
    this.checkIfUserCanEditEvent(data.event);
    console.log(this.data.contentID);
    if (router.url.includes('knowledge/displayer') || router.url.includes('articles/') || router.url.includes('notes/')) {
      this.view = 'todoDetails';
    } else if (!this.data.contentID) {
      this.view = 'todoDetails';
    } else {
      this.view = 'content';
    }

    this.contentID = data.contentID;
    if (this.action === 'edit') {
      this.dialogTitle = 'Edit';
    } else {
      // this.dialogTitle = 'Add Event';
      this.event = new SkillztankCalendarEvent({
        start: data.date,
        end: data.date,
      });
    }
    // this.eventForm = this.buildEventForm(this.event);
    // this.event.start = isNaN(this.event.start as any) ? moment() : this.event.start

    this.eventForm = new UntypedFormGroup({
      _id: new UntypedFormControl((this.event as any)._id),
      name: new UntypedFormControl(this.event.title, [Validators.required]),
      start: new UntypedFormControl(moment(this.event.start) || moment(), [Validators.required]),
      end: new UntypedFormControl(moment(this.event.end) || moment()),
      startTime: new UntypedFormControl((this.event as any).startTime || moment().format('HH:mm')),
      endTime: new UntypedFormControl((this.event as any).endTime || moment().add(1, 'h').format('HH:mm')),
      selectedFreq: new UntypedFormControl((this.event.meta ? this.event.meta.selectedFreq : 'Unrepeated') || 'Unrepeated'),
      interval: new UntypedFormControl(1),
      frequencyUnit: new UntypedFormControl('days'),
      weekDays: new UntypedFormControl(),
      weeksOfMonth: new UntypedFormControl(),
      monthlySelectionType: new UntypedFormControl('simple'),
      dayOfMonth: new UntypedFormControl(1),
      allDay: new UntypedFormControl(this.event.allDay),
      notes: new UntypedFormControl(this.event.meta.notes),
    });

    this.translate.onLangChange.subscribe((res) => this.translateOptions());

    // TODO supprimer cette façon de faire. L'interval n'est qu'un quickfix, il faut trouver une meilleur façon de faire
    // Le problème est qu'avec le bottomsheet les requetes asynchrone ne s'affiche une fois que la vue est rendu (rendered)
    // Il faut qu'une action se produise sur l'écran pour que le tout s'affiche dans le bottomsheet. Ce SetInterval est là pour déclencher
    // l'action. J'ai testé d'autres solution comme les output pour déclencher l'action, mais il faut attendre que le contenu soit complétement
    // rendered sur l'écran (ce qui est un évenement difficile à traquer)
    let intervalLoopCount = 0;
    const displayContentInterval = setInterval(() => {
      this.changeDetectorRef.markForCheck();
      intervalLoopCount++;
      if (intervalLoopCount > 10) {
        clearInterval(displayContentInterval);
      }
    }, 500);
  }

  get frequency() {
    return this.eventForm.get('selectedFreq').value;
  }
  get monthlySelectionType() {
    return this.eventForm.get('monthlySelectionType').value;
  }

  get frequencySentence() {
    const selectedFreq = this.eventForm.get('selectedFreq').value;
    if (selectedFreq != 'Unrepeated') {
      const hashMap = {
        Daily: 'Day',
        Weekly: 'Week',
        Monthly: 'Month',
      };

      const interval = this.eventForm.get('interval').value;
      let unit = this.translate.instant(`Calendar.${hashMap[selectedFreq]}`);
      const every = this.translate.instant('Calendar.Every');

      if (interval > 1 && unit.charAt(unit.length - 1) != 's') {
        unit = unit + 's';
      }
      return `${every} ${interval} ${unit}`;
    } else {
      return '';
    }
  }

  ngOnInit() {
    this.translateOptions();
    if (this.data.event) {
      this.shareMenuData.event = this.data.event;
    }

    if (!this.data.event) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');

      this.calendarService.addUsersInNewEvent({
        _id: userData.id,
        id: userData.id,
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        name: userData.firstName + ' ' + userData.lastName,
        image: this._sanitizer.bypassSecurityTrustUrl(userData.photo || 'assets/images/no_user.png'),
        role: 'Admin',
        userRole: 'Admin',
        type: 'user',
      });
    } else {
      this.calendarService.updateNewEventUsers(this.data.event.users);
    }
  }

  ngOnDestroy() {
    this.calendarService.updateNewEventUsers([]);
  }

  checkIfUserCanEditEvent(event) {
    if (this.data.action == 'add') {
      this.canEdit = true;
      return;
    }
    if (!event) {
      return;
    }
    this.canEdit = false;
    const userID = JSON.parse(localStorage.getItem('userData') || '{}').id;

    const userGroups = _.pluck(JSON.parse(localStorage.getItem('userGroups') || '[]'), '_id');
    for (const e of event.users) {
      if (userGroups.includes(e.id) && ['Admin', 'Writer'].includes(e.role)) {
        this.canEdit = true;
      }
    }

    for (const e of event.users) {
      if (e.id == userID && ['Admin', 'Writer'].includes(e.role)) {
        this.canEdit = true;
      } else if (e.id == userID && e.role == 'Reader') {
        this.canEdit = false;
      }
    }
  }

  goToThePage() {
    const content = this.data.event;
    if (this.dialogRef) {
      this.dialogRef.close({});
    } else {
      this.bottomSheetRef.dismiss({});
    }

    if (content.courseID) {
      this.router.navigateByUrl(`/knowledge/displayer/${content.courseID}/${content.sectionID}/${content.lectureID}`);
    } else if (content.blogID) {
      this.router.navigateByUrl(`/articles/post/${content.blogID}`);
    } else if (content.noteID) {
      this.router.navigateByUrl(`/articles/${content.noteID}`);
    }
  }

  translateOptions() {
    this.freq.map((e) => {
      e.name = this.translate.instant(`Calendar.${e.value}`);
    });

    this.weekDays.map((e) => {
      e.name = this.translate.instant(`Calendar.WeeksDayList.${e.value}`);
    });

    this.weeksOfMonth.map((e) => {
      e.name = this.translate.instant(`Calendar.WeeksOfMonthList.${e.value}`);
    });
  }

  setUserList(event) {
    this.userList = event;
  }

  checkDateValidity(date) {
    return date instanceof Date || moment.isMoment(date);
  }

  get maxDayIsReached() {
    const formValue = this.eventForm.value;
    const days = Math.ceil(moment.duration(moment(formValue.end).diff(moment(formValue.start))).asDays()) + 1;
    return days > 730;
  }

  formDatesAreValid() {
    const formValue = this.eventForm.value;
    if (!formValue.name.trim().length) {
      return false;
    }

    const startTimeArr = formValue.startTime.split(':');
    const endTimeArr = formValue.endTime.split(':');
    const start = moment(formValue.start).hours(startTimeArr[0]).minutes(startTimeArr[1]).utc(true).format();
    const end = moment(formValue.start).hours(endTimeArr[0]).minutes(endTimeArr[1]).utc(true).format();
    const days = Math.ceil(moment.duration(moment(formValue.end).diff(moment(formValue.start))).asDays()) + 1;

    const standardCheck = () => {
      return (
        this.checkDateValidity(formValue.start) &&
        this.checkDateValidity(formValue.end) &&
        moment(formValue.start).isBefore(moment(formValue.end)) &&
        moment(start).isBefore(moment(end)) &&
        formValue.interval &&
        days <= 730
      );
    };

    switch (formValue.selectedFreq) {
      case 'Unrepeated':
        return this.checkDateValidity(formValue.start) && moment(start).isBefore(moment(end));
      case 'Daily':
        return standardCheck();
      case 'Weekly':
        return standardCheck() && formValue.weekDays && formValue.weekDays.length > 0;
      case 'Monthly':
        return standardCheck() && formValue.monthlySelectionType == 'simple'
          ? formValue.dayOfMonth
          : formValue.weekDays && formValue.weekDays.length > 0 && formValue.weeksOfMonth && formValue.weeksOfMonth.length > 0;
    }
  }

  saveEvent() {
    // let userData = JSON.parse(localStorage.getItem('userData') || '{}')
    const formValue = this.eventForm.value;
    formValue.contentID = this.data.contentID;
    formValue.start = moment(formValue.start).hours(0).minutes(0).seconds(0);

    if (this.userList.length) {
      formValue.users = this.userList.map((e) => (e = { _id: e._id || e.id, role: e.role, type: e.type })) || [];
    } else {
      formValue.users = (this.dialogData || this.bottomSheetData).event.users || [];
    }
    // if (formValue.selectedFreq == 'Unrepeated') {
    //   formValue.end = moment(formValue.start).utc(true).format()
    // }
    formValue.end = moment(formValue.end).hours(0).minutes(0).seconds(0);
    // formValue.users.push({
    //   _id: userData.id,
    //   role: 'Admin',
    //   type: 'user'
    // })

    const startTimeArr = formValue.startTime.split(':');
    const endTimeArr = formValue.endTime.split(':');

    function createCalendarSet(start, end, interval = 1) {
      function weekOfMonth(input = moment()) {
        const firstDayOfMonth = input.clone().startOf('month');
        const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');
        const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');
        return Math.ceil((input.date() + offset) / 7);
      }

      const dates = [];

      let week = 0;
      let month = 0;
      let previousWeek = moment(start).week();
      let previousMonth = moment(start).month();
      const days = Math.ceil(moment.duration(moment(end).diff(moment(start))).asDays()) + 1;
      const dayRange = [...Array(days).keys()];

      let date = moment(start);
      for (const day of dayRange) {
        if (day != 0) {
          date = date.add(1, 'days');
        }

        if (previousWeek != moment(date).week()) {
          previousWeek = moment(date).week();
          week++;
        }

        if (previousMonth != moment(date).month()) {
          previousMonth = moment(date).month();
          month++;
        }
        dates.push({
          date: date.format(),
          weekday: date.weekday(),
          weekOfMonth: weekOfMonth(date),
          dayOfMonth: date.get('date'),
          day,
          modulusDay: day % interval,
          week,
          modulusWeek: week % interval,
          month,
          modulusMonth: month % interval,
        });
      }
      // let displaydates = dates.map(dateObj=> {return {date: dateObj.date, weekday:dateObj.weekday}})
      return dates;
    }

    function eventDateTime(date) {
      return {
        start: moment(date).hours(startTimeArr[0]).minutes(startTimeArr[1]).utc(true).format(),
        end: moment(date).hours(endTimeArr[0]).minutes(endTimeArr[1]).utc(true).format(),
        contents: [],
      };
    }

    if (this.data.action != 'edit') {
      let dates = createCalendarSet(formValue.start, formValue.end, formValue.interval);
      switch (formValue.selectedFreq) {
        case 'Daily':
          dates = dates.filter((e) => e.modulusDay == 0).map((e) => eventDateTime(e.date));
          break;
        case 'Weekly':
          dates = dates
            .filter((e) => e.modulusWeek == 0)
            .filter((e) => formValue.weekDays.includes(e.weekday))
            .map((e) => eventDateTime(e.date));
          break;
        case 'Monthly':
          if (formValue.monthlySelectionType == 'simple') {
            dates = dates
              .filter((e) => e.modulusMonth == 0)
              .filter((e) => e.dayOfMonth == formValue.dayOfMonth)
              .map((e) => eventDateTime(e.date));
          } else {
            dates = dates
              .filter((e) => e.modulusMonth == 0)
              .filter((e) => formValue.weeksOfMonth.includes(e.weekOfMonth))
              .filter((e) => formValue.weekDays.includes(e.weekday))
              .map((e) => eventDateTime(e.date));
          }
          break;
        default:
          dates = dates.map((e) => eventDateTime(e.date));
          break;
      }

      const event = { ...this.eventForm.value, dates };

      this.toast.snackbar.open(this.translate.instant('Snackbar.EventCreatedSuccess'), 'Ok', { duration: 2000 });

      if (this.dialogRef) {
        this.dialogRef.close({ event, action: 'save' });
      } else {
        this.bottomSheetRef.dismiss({ event, action: 'save' });
      }
    } else {
      formValue.start = moment(formValue.start).hours(startTimeArr[0]).minutes(startTimeArr[1]).utc(true).format();
      formValue.end = moment(formValue.start).hours(endTimeArr[0]).minutes(endTimeArr[1]).utc(true).format();
      const event = { ...this.eventForm.value };
      this.toast.snackbar.open(this.translate.instant('Snackbar.EventEditedSuccess'), 'Ok', { duration: 2000 });

      if (this.dialogRef) {
        this.dialogRef.close({ event, action: 'edit' });
      } else {
        this.bottomSheetRef.dismiss({ event, action: 'edit' });
      }
    }
  }

  deleteEvent() {
    const event = { ...this.eventForm.value };
    if (this.dialogRef) {
      this.dialogRef.close({ event, action: 'delete' });
    } else {
      this.bottomSheetRef.dismiss({ event, action: 'delete' });
    }
  }

  deleteAllOccurrencesOfEvent() {
    const event = { ...this.eventForm.value };
    if (this.dialogRef) {
      this.dialogRef.close({ event, action: 'delete-all-occurrences' });
    } else {
      this.bottomSheetRef.dismiss({ event, action: 'delete-all-occurrences' });
    }
  }
}
